import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef, inject, DestroyRef } from '@angular/core';
import { SidenavService } from '../services/util/sidenav.service';
import { MatSidenav } from '@angular/material/sidenav';
import { ScrollService } from '../services/util/scroll.service';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { TourService } from '../services/util/tour.service';
import { SessionManagementService } from '../services/util/session-management.service';
import { FabricService } from '../services/fabric/fabric.service';
import { Permission } from '../models/principal/permission';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit, AfterViewInit {
  @ViewChild('rightSidenav', { static: true }) private rightSidenav: MatSidenav;
  @ViewChild('container', { static: true, read: ViewContainerRef }) private viewContainerRef: ViewContainerRef;
  @ViewChild('scrollableContainer') private scrollableContainer;
  isEnterprise: boolean;

  windowHeight = 0;
  windowScrollHeight = 0;
  windowOffsetHeight = 0;
  scrollToBottom = false;
  private destroyRef = inject(DestroyRef);

  constructor(public sidenavService: SidenavService, private scrollService: ScrollService,
              private router: Router, public authService: AuthService,
              private tourService: TourService, private sessionService: SessionManagementService,
              private fabricService: FabricService) {
  }

  ngOnInit(): void {
    this.sidenavService.setRightSidenav(this.rightSidenav);
    this.sidenavService.setViewContainerRef(this.viewContainerRef);
    this.addNavigationHandler();
    // this.startSessionMonitoring();
    this.isEnterprise = this.authService.hasPermission(Permission.VIEW_ENTERPRISE);
  }

  ngAfterViewInit(): void {
    this.scrollService.setScrollableContainer(this.scrollableContainer.elementRef.nativeElement);
  }

  scroll(event: any): void {
    this.scrollService.publishScrollEvent(event);
    this.windowScrollHeight = event.target.scrollHeight;
    this.windowOffsetHeight = Math.round(event.target.offsetHeight + event.target.scrollTop);
     if (this.windowOffsetHeight > event.target.scrollHeight) {
      this.scrollToBottom = true;
    }
    if(event.target.scrollTop === 0) {
      this.scrollToBottom = false;
      this.windowHeight = 0;
    }
    else if(Math.round(this.windowOffsetHeight) === event.target.scrollHeight
    || Math.round(this.windowOffsetHeight) === (event.target.scrollHeight -1)) {
      this.scrollToBottom = true;
    }
  }

  windowScroll(): void {
    if(this.windowHeight ===  0 && !this.scrollToBottom) {
      this.windowHeight = this.windowHeight + window.innerHeight;
      this.scrollToBottom = false;
    } else if ((this.windowOffsetHeight === this.windowScrollHeight)
    ||  (this.scrollToBottom && this.windowOffsetHeight <= this.windowScrollHeight)){
      this.windowHeight = 0;
    } else if (this.windowHeight <= this.windowScrollHeight){
      this.windowHeight = this.windowHeight + window.innerHeight;
    }

    if(this.windowHeight ===  0) {
      this.scrollToBottom = false;
    }

    this.scrollService.scrollTo(this.windowHeight);

  }

  private startSessionMonitoring(): void {
    this.sessionService.expirationEvent
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(expired => {
        if (expired) {
          this.fabricService.getClient().isAnonymousProvider = true;
          this.authService.logout();
        }
      });
  }

  private addNavigationHandler(): void {
    this.router.events
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((evt) => {
          if (!(evt instanceof NavigationEnd)) {
            return;
          }
          this.sidenavService.closeRightSidenav();
          this.scrollService.scrollTo(0);
          this.tourService.hideTour();
        });
  }
}
